<form [formGroup]="noteForm" (ngSubmit)="onAdd()">
	<div class="p-fluid">
		<div *ngIf="!dispatcherMode" class="grid pl-3 pr-3">
			<div class="col-4">
				<div class="flex align-items-center field">
					<label for="critical" style="width: 60px; margin-top: 0.5rem">Critical</label>
					<p-inputSwitch id="critical" formControlName="critical"></p-inputSwitch>
				</div>
			</div>
			<div class="col-4">
				<div class="flex align-items-center field">
					<label for="patientPopup" style="width: 60px">Patient Popup</label>
					<p-inputSwitch id="patientPopup" formControlName="patientPopup"></p-inputSwitch>
				</div>
			</div>
			<div class="col-4">
				<div class="flex align-items-center field">
					<label for="orderPopup" style="width: 60px">Order Popup</label>
					<p-inputSwitch id="orderPopup" formControlName="orderPopup"></p-inputSwitch>
				</div>
			</div>
			<div *ngIf="showAutoApplyToOrderComment" class="col-6">
				<div class="flex align-items-center field">
					<label for="autoApplyToOrderComment" style="width: 110px">Auto-Apply to Order Comments</label>
					<p-inputSwitch
						id="autoApplyToOrderComment"
						formControlName="autoApplyToOrderComment"
					></p-inputSwitch>
				</div>
			</div>
		</div>

		<div class="card grid">
			<div class="field col-12">
				<label for="category">Category*</label>
				<p-dropdown
					id="category"
					[options]="categories"
					formControlName="categoryId"
					optionLabel="name"
					optionValue="id"
					placeholder="Select a category"
				></p-dropdown>
			</div>
			<div class="field col-12">
				<label for="subject">Subject*</label>
				<p-dropdown
					*ngIf="hasPresetSubjects"
					id="subject"
					[options]="subjectOptions"
					formControlName="subject"
					placeholder="Select a subject"
				></p-dropdown>
				<input
					*ngIf="!hasPresetSubjects"
					id="subject"
					type="text"
					pInputText
					formControlName="subject"
					placeholder="Enter subject"
				/>
			</div>

			<!-- Note Row -->
			<div class="field col-12">
				<label for="note">Note*</label>
				<app-note-markdown-editor
					formControlName="note"
					[rows]="6"
					placeholder="Enter note"
				></app-note-markdown-editor>
			</div>
		</div>

		<div class="flex justify-content-end gap-2">
			<p-button label="Cancel" severity="secondary" type="button" (click)="onCancel()" />
			<p-button label="Add" type="submit" [disabled]="noteForm.invalid" />
		</div>
	</div>
</form>
